// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Router from "common/src/Router.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function LbTypeSelect(Props) {
  var region = Props.region;
  var typ = Props.typ;
  var router = Router.use(undefined);
  var goToRanked = React.useCallback((function (param) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: {
                            TAG: /* Ranked */0,
                            _0: region
                          }
                        }), undefined, undefined);
        }), [region]);
  var goToHr = React.useCallback((function (param) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: {
                            TAG: /* Hyperroll */1,
                            _0: region
                          }
                        }), undefined, undefined);
        }), [region]);
  var goToDuo = React.useCallback((function (param) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: {
                            TAG: /* Duo */2,
                            _0: region
                          }
                        }), undefined, undefined);
        }), [region]);
  var goToBookmarks = React.useCallback((function (param) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: /* Bookmarks */0
                        }), undefined, undefined);
        }), []);
  var goToUnit = React.useCallback((function (param) {
          return router.push(Route.toString({
                          TAG: /* Leaderboards */7,
                          _0: {
                            TAG: /* Unit */3,
                            _0: undefined
                          }
                        }), undefined, undefined);
        }), []);
  return React.createElement(ContentSection.make, {
              className: "mb-6 w-screen sm:w-auto",
              children: React.createElement(Tabs, {
                    variant: "scrollable",
                    children: null,
                    value: typ,
                    onChange: (function (param, v) {
                        switch (v) {
                          case /* Ranked */0 :
                              return Curry._1(goToRanked, undefined);
                          case /* Duo */1 :
                              return Curry._1(goToDuo, undefined);
                          case /* Hr */2 :
                              return Curry._1(goToHr, undefined);
                          case /* Unit */3 :
                              return Curry._1(goToUnit, undefined);
                          case /* Bookmarks */4 :
                              return Curry._1(goToBookmarks, undefined);
                          
                        }
                      })
                  }, React.createElement(Tab, {
                        label: "Ranked",
                        value: /* Ranked */0
                      }), React.createElement(Tab, {
                        label: "Double Up",
                        value: /* Duo */1
                      }), React.createElement(Tab, {
                        label: "Bookmarks",
                        value: /* Bookmarks */4
                      }), React.createElement(Tab, {
                        label: "Unit",
                        value: /* Unit */3
                      })),
              noPadding: true
            });
}

var make = LbTypeSelect;

export {
  make ,
  
}
/* Route Not a pure module */
